import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-alert",
  "use": "icon-alert-usage",
  "viewBox": "0 0 33 33",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 33 33\" id=\"icon-alert\"><path fill=\"red\" d=\"M16.5 0C25.612 0 33 7.387 33 16.5S25.612 33 16.5 33 0 25.614 0 16.5 7.388 0 16.5 0zm.5 21a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm0-13c-1.657 0-3 1.296-3 2.894s2.05 7.015 2.05 7.015c.525 1.453 1.38 1.456 1.9 0 0 0 2.05-5.417 2.05-7.015S18.657 8 17 8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol